import React, { useEffect } from "react";
import { useState } from "react";
import useForm from "../../app/hooks/useForm";
import useControls from "../../app/hooks/useControls";
import Moment from "react-moment";
import { getFieldData } from "../../services/appService";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addNewRates, getAllRates, getRateAddedStatus, loadAllRates } from "../../app/store/rates";
import { getCurrentUser } from "../../services/authService";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";

const AddEditRates = (props) => {

    const { selectedObj, editType, handleDurationShowHide, hideHeader } = props;

    const [rateHistory, setRateHistory] = useState([]);
    const [entityType, setEntityType] = useState([]);

    const allRatesSelector = useSelector(getAllRates);
    const rateAddedStatusSelector = useSelector(getRateAddedStatus)

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        if (editType !== "") {
            if (selectedObj?.rates) {
                const data = { ...stateData };
                data["existingSubcontractorRate"] = selectedObj.rates.subcontractorRate;
                data["existingRecruiterRate"] = selectedObj.rates.recruiterRate;
                data["existingAgencyRate"] = selectedObj.rates.agencyRate;
                data["existingCandidateRate"] = selectedObj.rates.candidateRate;

                data["dateCandidateRate"] = getDateFormat(selectedObj.rates.candidateEffectiveDate);
                data["dateAgencyRate"] = getDateFormat(selectedObj.rates.agencyEffectiveDate);
                data["dateSubcontractorRate"] = getDateFormat(selectedObj.rates.subcontractorEffectiveDate);
                data["dateRecruiterRate"] = getDateFormat(selectedObj.rates.recruiterEffectiveDate);

                data["notes"] = selectedObj.rates.notes;

                setStateData(data);
            }
            const entityType = getFieldData(
                selectedObj.performerData,
                "candidateonboardingform",
                "CandidateEntity"
            );
            setEntityType(entityType);
            dispatch(loadAllRates(selectedObj.performerid));
        }
    }, [editType]);

    const getDateFormat = (dtObj) => {
        const dt = new Date(dtObj);
        let divider = dt.getMonth() < 9 ? "-0" : "-";
        let divider1 = dt.getDate() < 9 ? "-0" : "-";
        const newDt =
            dt.getFullYear() +
            divider +
            (dt.getMonth() + 1) +
            divider1 +
            dt.getDate();
        return newDt;
    };

    useEffect(() => {
        if (allRatesSelector) setRateHistory(allRatesSelector);
    }, [allRatesSelector]);

    const schema = {};

    const doSubmit = async () => {
        const data = { ...stateData };
        const rateObj = {
            performerId: selectedObj.performerid,
            addedBy: currentUser.id,
            notes: data["notes"],
            subcontractorRate:
                !data["newSubcontractorRate"]
                    ? data["existingSubcontractorRate"]
                    : data["newSubcontractorRate"],
            recruiterRate:
                !data["newRecruiterRate"]
                    ? data["existingRecruiterRate"]
                    : data["newRecruiterRate"],
            candidateRate:
                !data["newCandidateRate"]
                    ? data["existingCandidateRate"]
                    : data["newCandidateRate"],
            agencyRate:
                !data["newAgencyRate"]
                    ? data["existingAgencyRate"]
                    : data["newAgencyRate"],
            candidateEffectiveDate: data["dateCandidateRate"],
            agencyEffectiveDate: data["dateAgencyRate"],
            subcontractorEffectiveDate: data["dateSubcontractorRate"],
            recruiterEffectiveDate: data["dateRecruiterRate"],
        };
        const result = await getConfirmAlert("Warning", "Are you sure you want to Edit Rates?", "warning");
        if (result.isConfirmed)
            dispatch(addNewRates(rateObj))
    }

    useEffect(() => {
        if (rateAddedStatusSelector) {
            getAlert("", "Rates saved Successfully", "success");
            if (selectedObj?.performerid)
                dispatch(loadAllRates(selectedObj.performerid));

            setStateData(null);
            handleDurationShowHide("", "save", -1)
        }
    }, [rateAddedStatusSelector])

    const { validate, handleChange, stateData, setStateData,
        stateErrors, setStateErrors, handleSubmit } = useForm(schema, doSubmit);

    const { renderSelect, renderInput, renderTextArea } = useControls(stateData, stateErrors, handleChange, schema);
    // console.log(stateData, "std111")

    return (
        <React.Fragment>
            <style>{`
        /* ── Scoped Style for AddEditRates ── */
        @keyframes aerFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Header Section (Document Style) ── */
        .aer-header {
          display: flex; align-items: flex-start; justify-content: space-between;
          flex-wrap: wrap; gap: 18px; padding: 22px 24px 18px;
          background: #ffffff;
          border-bottom: 1px solid #dbe2ea; margin-bottom: 20px;
          border-radius: 0;
        }
        .aer-header-left { display: flex; align-items: flex-start; gap: 14px; flex: 1; }
        .aer-icon-box {
          width: 44px; height: 44px; border-radius: 0;
          background: #f8fafc; border: 1px solid #cbd5e1;
          display: flex; align-items: center; justify-content: center;
          color: #1e293b; font-size: 18px; flex-shrink: 0;
          box-shadow: none;
        }
        .aer-title-block { min-width: 0; }
        .aer-kicker {
          display: inline-flex; align-items: center; gap: 6px;
          margin: 0 0 5px; color: #2563eb; font-size: 12px;
          font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase;
        }
        .aer-title { font-size: 18px; font-weight: 500; color: #1e293b; margin: 0; line-height: 1.2; }
        .aer-header-meta { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
        .aer-header-right { display: flex; align-items: center; gap: 8px; margin-top: 4px; }
        .aer-meta-pill {
          display: inline-flex; align-items: center; gap: 6px;
          min-height: 26px; padding: 3px 9px; border-radius: 0; background: #ffffff;
          border: 1px solid #cbd5e1; color: #475569; font-size: 12px; font-weight: 500;
        }
        .aer-meta-pill i { font-size: 12px; }
        .aer-meta-pill.meta-id i { color: #1d4ed8; }
        .aer-meta-pill.meta-person i { color: #047857; }
        .aer-meta-pill.meta-email i { color: #0369a1; }

        .aer-container {
          animation: aerFadeIn 0.3s ease both;
          width: 100%;
          background: #ffffff;
          border: 1px solid rgba(226, 232, 240, 0.9);
          border-radius: 0;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
          margin-bottom: 24px;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }
        .aer-container.hide-inner-header .aer-header {
          display: none;
        }
        .aer-container.hide-inner-header .aer-content-body {
          padding-top: 24px;
        }
        .aer-content-body { padding: 0 24px 24px; }

        /* ── Modern Rate Entry Cards ── */
        .aer-rate-card {
          border: 1.5px solid #f1f5f9; border-radius: 0;
          padding: 16px; margin-bottom: 16px; background: #ffffff;
          transition: all 0.2s ease;
        }
        .aer-rate-card:hover {
          border-color: #e2e8f0; box-shadow: 0 4px 12px rgba(15,23,42,0.03);
          transform: translateY(-1px);
        }
        .aer-rate-card-header {
          display: flex; align-items: center; gap: 10px; margin-bottom: 14px;
          padding-bottom: 10px; border-bottom: 1px dashed #f1f5f9;
        }
        .aer-rate-card-icon {
          width: 28px; height: 28px; border-radius: 0;
          display: flex; align-items: center; justify-content: center;
          background: rgba(37, 99, 235, 0.06); color: #2563eb; font-size: 14px;
        }
        .aer-rate-card-title { font-size: 14px; font-weight: 500; color: #1e293b; margin: 0; }

        /* ── wf-style input wrapper (from AddWorkflowPerformer) ── */
        .aer-wf-input-wrap { position: relative; width: 100%; }
        .aer-wf-input-icon {
          display: none;
        }
        .aer-wf-input-wrap:focus-within .aer-wf-input-icon { color: #2563eb; }

        /* Form Controls with Icon Spacing */
        .aer-field-group .form-control.has-icon {
          padding-left: 12px !important;
        }

        /* ── Form Fields & Labels ── */
        .aer-field-group { margin-bottom: 14px; }
        .aer-field-group label,
        .aer-notes-group label {
          font-size: 12px; font-weight: 600; color: #64748b;
          text-transform: uppercase; letter-spacing: 0.7px; margin-bottom: 6px;
          display: flex; align-items: center; gap: 5px;
        }
        .aer-field-group label i,
        .aer-notes-group label i { display: none; }

        .aer-field-group .form-control {
          border-radius: 0 !important; border: 1.5px solid #e2e8f0 !important;
          padding: 8px 12px !important; font-size: 14px !important; font-weight: 400 !important;
          color: #1e293b !important; background: #ffffff !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 2px rgba(0,0,0,0.02) !important;
        }
        .aer-field-group .form-control:hover { border-color: #cbd5e1 !important; }
        .aer-field-group .form-control:focus {
          border-color: #2563eb !important; background: #fafbff !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
        }
        .aer-field-group .form-control:disabled { background: #f8fafc !important; color: #94a3b8 !important; }

        /* ── Notes Block ── */
        .aer-notes-group { margin-top: 4px; margin-bottom: 18px; width: 100%; }
        .aer-notes-group textarea {
          border-radius: 0 !important; border: 1.5px solid #e2e8f0 !important;
          padding: 10px 14px !important; font-size: 14px !important; font-weight: 400 !important;
          color: #1e293b !important; background: #ffffff !important;
          transition: all 0.2s ease !important; min-height: 80px;
        }

        /* ── Split Grid Columns Styling ── */
        @media (min-width: 992px) {
          .aer-left-col {
            border-right: 1px solid #f1f5f9;
            padding-right: 28px;
          }
          .aer-right-col {
            padding-left: 28px;
          }
        }
        .aer-submit-btn {
          display: inline-flex; align-items: center; justify-content: center;
          gap: 8px; font-size: 14px; font-weight: 500; border-radius: 0;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          cursor: pointer; transition: all 0.2s ease;
          min-height: 38px; padding: 0 14px; border: 1px solid #2563eb; outline: none;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2);
          background: #2563eb; color: #ffffff;
        }
        .aer-submit-btn:hover {
          background: #1d4ed8; border-color: #1d4ed8;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.25);
        }

        .aer-cancel-btn {
          display: inline-flex; align-items: center; justify-content: center;
          gap: 8px; font-size: 14px; font-weight: 500; border-radius: 0;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          cursor: pointer; transition: all 0.2s ease;
          min-height: 38px; padding: 0 14px; border: 1px solid #cbd5e1; outline: none;
          background: #ffffff; color: #1e293b;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }
        .aer-cancel-btn:hover {
          background: #f8fafc; border-color: #94a3b8; color: #1e293b;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12);
        }

        /* ── History Table Styling ── */
        .aer-history-title {
          font-size: 14px; font-weight: 500; color: #1e293b;
          letter-spacing: 0.1px; margin-top: 24px; margin-bottom: 12px;
          display: flex; align-items: center; gap: 6px; width: 100%;
        }
        .aer-history-title i { color: #64748b; font-size: 14px; }
        .aer-history-count {
          display: inline-flex; align-items: center; justify-content: center;
          min-width: 20px; height: 20px; padding: 0 6px;
          border-radius: 0; background: #2563eb; color: #fff;
          font-size: 12px; font-weight: 600;
        }

        .aer-table {
          width: 100% !important; border-collapse: collapse !important; border-spacing: 0 !important;
        }
        .aer-thead th {
          background: #f8fafc !important; color: #64748b !important; font-size: 12px !important;
          font-weight: 600 !important; text-transform: uppercase !important; letter-spacing: 0.7px !important;
          padding: 12px 16px !important; border: none !important; border-bottom: 2px solid #e2e8f0 !important;
          font-family: "Open Sans", sans-serif !important;
        }
        .aer-table-row {
          background: #ffffff !important; transition: all 0.2s ease !important;
        }
        .aer-table-row:hover {
          background: #f8fafc !important;
        }
        .aer-table-row td {
          padding: 12px 16px !important; font-size: 14px !important; font-weight: 400 !important;
          color: #1e293b !important;
          border: none !important; border-bottom: 1px solid #f1f5f9 !important; vertical-align: middle !important;
          font-family: "Open Sans", sans-serif !important;
        }
        .aer-notes-group { margin-top: 18px; margin-bottom: 18px; width: 100%; }
      `}</style>

            {editType === "rate" && stateData && (
                <div className={`aer-container mt-2${hideHeader ? " hide-inner-header" : ""}`}>
                    {/* ═══ HEADER SECTION ═══ */}
                    <div className="aer-header">
                        <div className="aer-header-left">
                            <div className="aer-icon-box">
                                <i className="fa fa-money" />
                            </div>
                            <div className="aer-title-block">
                                <h2 className="aer-title">Rate Details</h2>
                                <div className="aer-header-meta">
                                    <span className="aer-meta-pill meta-id">
                                        <i className="fa fa-id-badge" /> ID: {selectedObj?.performerid}
                                    </span>
                                    <span className="aer-meta-pill meta-person">
                                        <i className="fa fa-user" /> {selectedObj?.performername} {selectedObj?.lastName}
                                    </span>
                                    {selectedObj?.performeremail && (
                                        <span className="aer-meta-pill meta-email">
                                            <i className="fa fa-envelope-o" /> {selectedObj.performeremail}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="aer-header-right">
                            <button
                                type="button"
                                className="aer-cancel-btn mr-2"
                                onClick={() => {
                                    if (selectedObj?.performerid > 0)
                                        dispatch(loadAllRates(selectedObj.performerid));
                                }}
                                title="Refresh Rate History"
                            >
                                <i className="fa fa-refresh" /> Refresh
                            </button>
                            <button
                                type="button"
                                className="aer-cancel-btn"
                                onClick={() => handleDurationShowHide("", "", -1)}
                            >
                                <i className="fa fa-arrow-left" /> Back
                            </button>
                        </div>
                    </div>

                    <div className="aer-content-body">
                        <div className="row">
                            {/* Left Column: Rate Modification Form */}
                            <div className="col-lg-5 col-md-12 aer-left-col">
                                
                                {/* Client/Agency Rate Card */}
                                <div className="aer-rate-card">
                                    <div className="aer-rate-card-header">
                                        <div className="aer-rate-card-icon"><i className="fa fa-briefcase" /></div>
                                        <h4 className="aer-rate-card-title">Client / Agency Rate</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 aer-field-group">
                                            <label className="form-control-label">
                                                <i className="fa fa-money" /> Existing
                                            </label>
                                            <div className="aer-wf-input-wrap">
                                                <i className="fa fa-usd aer-wf-input-icon" aria-hidden="true" />
                                                <input
                                                    type="number"
                                                    className="form-control has-icon"
                                                    value={stateData.existingAgencyRate || ""}
                                                    disabled={true}
                                                    placeholder="Existing"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 aer-field-group">
                                            <label className="form-control-label">
                                                <i className="fa fa-plus-circle" /> New Rate
                                            </label>
                                            <div className="aer-wf-input-wrap">
                                                <i className="fa fa-usd aer-wf-input-icon" aria-hidden="true" />
                                                <input
                                                    type="number"
                                                    name="newAgencyRate"
                                                    className="form-control has-icon"
                                                    value={stateData.newAgencyRate || ""}
                                                    onChange={handleChange}
                                                    placeholder="Rate"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 aer-field-group">
                                            <label className="form-control-label" htmlFor="dateAgencyRate">
                                                <i className="fa fa-calendar" /> Effective
                                            </label>
                                            <div className="aer-wf-input-wrap">
                                                <i className="fa fa-calendar aer-wf-input-icon" aria-hidden="true" />
                                                <input
                                                    type="date"
                                                    id="dateAgencyRate"
                                                    name="dateAgencyRate"
                                                    className="form-control has-icon"
                                                    value={stateData.dateAgencyRate || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            {stateErrors.dateAgencyRate && <div className="alert alert-danger">{stateErrors.dateAgencyRate}</div>}
                                        </div>
                                    </div>
                                </div>

                                {/* Recruiter Rate Card */}
                                <div className="aer-rate-card">
                                    <div className="aer-rate-card-header">
                                        <div className="aer-rate-card-icon"><i className="fa fa-user-circle" /></div>
                                        <h4 className="aer-rate-card-title">Recruiter Rate</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 aer-field-group">
                                            <label className="form-control-label">
                                                <i className="fa fa-money" /> Existing
                                            </label>
                                            <div className="aer-wf-input-wrap">
                                                <i className="fa fa-usd aer-wf-input-icon" aria-hidden="true" />
                                                <input
                                                    type="number"
                                                    className="form-control has-icon"
                                                    value={stateData.existingRecruiterRate || ""}
                                                    disabled={true}
                                                    placeholder="Existing"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 aer-field-group">
                                            <label className="form-control-label">
                                                <i className="fa fa-plus-circle" /> New Rate
                                            </label>
                                            <div className="aer-wf-input-wrap">
                                                <i className="fa fa-usd aer-wf-input-icon" aria-hidden="true" />
                                                <input
                                                    type="number"
                                                    name="newRecruiterRate"
                                                    className="form-control has-icon"
                                                    value={stateData.newRecruiterRate || ""}
                                                    onChange={handleChange}
                                                    placeholder="Rate"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 aer-field-group">
                                            <label className="form-control-label" htmlFor="dateRecruiterRate">
                                                <i className="fa fa-calendar" /> Effective
                                            </label>
                                            <div className="aer-wf-input-wrap">
                                                <i className="fa fa-calendar aer-wf-input-icon" aria-hidden="true" />
                                                <input
                                                    type="date"
                                                    id="dateRecruiterRate"
                                                    name="dateRecruiterRate"
                                                    className="form-control has-icon"
                                                    value={stateData.dateRecruiterRate || ""}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            {stateErrors.dateRecruiterRate && <div className="alert alert-danger">{stateErrors.dateRecruiterRate}</div>}
                                        </div>
                                    </div>
                                </div>

                                {/* Candidate/Subcontractor Rate Card */}
                                <div className="aer-rate-card">
                                    <div className="aer-rate-card-header">
                                        <div className="aer-rate-card-icon"><i className="fa fa-id-card-o" /></div>
                                        <h4 className="aer-rate-card-title">
                                            {entityType === "C2C Basis" ? "Subcontractor" : "Candidate"} Rate
                                        </h4>
                                    </div>
                                    <div className="row">
                                        {entityType === "C2C Basis" ? (
                                            <>
                                                <div className="col-md-4 aer-field-group">
                                                    <label className="form-control-label">
                                                        <i className="fa fa-money" /> Existing
                                                    </label>
                                                    <div className="aer-wf-input-wrap">
                                                        <i className="fa fa-usd aer-wf-input-icon" aria-hidden="true" />
                                                        <input
                                                            type="number"
                                                            className="form-control has-icon"
                                                            value={stateData.existingSubcontractorRate || ""}
                                                            disabled={true}
                                                            placeholder="Existing"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 aer-field-group">
                                                    <label className="form-control-label">
                                                        <i className="fa fa-plus-circle" /> New Rate
                                                    </label>
                                                    <div className="aer-wf-input-wrap">
                                                        <i className="fa fa-usd aer-wf-input-icon" aria-hidden="true" />
                                                        <input
                                                            type="number"
                                                            name="newSubcontractorRate"
                                                            className="form-control has-icon"
                                                            value={stateData.newSubcontractorRate || ""}
                                                            onChange={handleChange}
                                                            placeholder="Rate"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 aer-field-group">
                                                    <label className="form-control-label" htmlFor="dateSubcontractorRate">
                                                        <i className="fa fa-calendar" /> Effective
                                                    </label>
                                                    <div className="aer-wf-input-wrap">
                                                        <i className="fa fa-calendar aer-wf-input-icon" aria-hidden="true" />
                                                        <input
                                                            type="date"
                                                            id="dateSubcontractorRate"
                                                            name="dateSubcontractorRate"
                                                            className="form-control has-icon"
                                                            value={stateData.dateSubcontractorRate || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    {stateErrors.dateSubcontractorRate && <div className="alert alert-danger">{stateErrors.dateSubcontractorRate}</div>}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="col-md-4 aer-field-group">
                                                    <label className="form-control-label">
                                                        <i className="fa fa-money" /> Existing
                                                    </label>
                                                    <div className="aer-wf-input-wrap">
                                                        <i className="fa fa-usd aer-wf-input-icon" aria-hidden="true" />
                                                        <input
                                                            type="number"
                                                            className="form-control has-icon"
                                                            value={stateData.existingCandidateRate || ""}
                                                            disabled={true}
                                                            placeholder="Existing"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 aer-field-group">
                                                    <label className="form-control-label">
                                                        <i className="fa fa-plus-circle" /> New Rate
                                                    </label>
                                                    <div className="aer-wf-input-wrap">
                                                        <i className="fa fa-usd aer-wf-input-icon" aria-hidden="true" />
                                                        <input
                                                            type="number"
                                                            name="newCandidateRate"
                                                            className="form-control has-icon"
                                                            value={stateData.newCandidateRate || ""}
                                                            onChange={handleChange}
                                                            placeholder="Rate"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 aer-field-group">
                                                    <label className="form-control-label" htmlFor="dateCandidateRate">
                                                        <i className="fa fa-calendar" /> Effective
                                                    </label>
                                                    <div className="aer-wf-input-wrap">
                                                        <i className="fa fa-calendar aer-wf-input-icon" aria-hidden="true" />
                                                        <input
                                                            type="date"
                                                            id="dateCandidateRate"
                                                            name="dateCandidateRate"
                                                            className="form-control has-icon"
                                                            value={stateData.dateCandidateRate || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    {stateErrors.dateCandidateRate && <div className="alert alert-danger">{stateErrors.dateCandidateRate}</div>}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="aer-notes-group">
                                    <label className="form-control-label" htmlFor="notes">
                                        <i className="fa fa-sticky-note-o" /> Notes / Remarks
                                    </label>
                                    {renderTextArea("notes", "")}
                                </div>

                                <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginBottom: "20px" }}>
                                    <button 
                                        type="button" 
                                        className="aer-cancel-btn"
                                        onClick={() => handleDurationShowHide("", "", -1)}
                                    >
                                        <i className="fa fa-arrow-left" aria-hidden="true" /> Back
                                    </button>
                                    <button
                                        type="button"
                                        className="aer-submit-btn"
                                        onClick={handleSubmit}
                                    >
                                        <i className="fa fa-check" aria-hidden="true" /> Save Changes
                                    </button>
                                </div>
                            </div>

                            {/* Right Column: Rate History Log */}
                            <div className="col-lg-7 col-md-12 aer-right-col">
                                <div className="aer-history-title">
                                    <i className="fa fa-history" />
                                    <span>Rate Change History</span>
                                    {rateHistory.length > 0 && (
                                        <span className="aer-history-count">{rateHistory.length}</span>
                                    )}
                                </div>

                                <div className="table-responsive" style={{ border: "1px solid #e2e8f0", borderRadius: 0, overflow: "hidden" }}>
                                    <table className="table aer-table m-0">
                                        <thead className="aer-thead">
                                            <tr>
                                                <th>Date & Time</th>
                                                <th>{entityType === "C2C Basis" ? "Sub" : "Cand"} Rate</th>
                                                <th>Recruiter</th>
                                                <th>Agency</th>
                                                <th style={{ minWidth: "150px" }}>Notes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rateHistory.length === 0 ? (
                                                <tr className="aer-table-row">
                                                    <td colSpan={5} className="text-center py-4 text-muted" style={{ fontSize: "14px", color: "#64748b" }}>
                                                        <i className="fa fa-info-circle mr-1" /> No rate change history found.
                                                    </td>
                                                </tr>
                                            ) : (
                                                rateHistory.map((item, key) => (
                                                    <tr key={`rate-history-${key}`} className="aer-table-row">
                                                        <td style={{ whiteSpace: "nowrap" }}>
                                                            <Moment format="MMM Do YYYY">{item.addedDateTime}</Moment>
                                                            <div className="text-muted" style={{ fontSize: "12px", color: "#64748b", marginTop: "2px" }}>
                                                                <Moment format="h:mm a">{item.addedDateTime}</Moment>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style={{ color: "#1e293b", fontWeight: "400" }}>
                                                                ${entityType === "C2C Basis" ? item.subcontractorRate : item.candidateRate}
                                                            </div>
                                                            <div className="text-muted" style={{ fontSize: "12px", color: "#64748b" }}>
                                                                <Moment format="MMM DD">{entityType === "C2C Basis" ? item.subcontractorEffectiveDate : item.candidateEffectiveDate}</Moment>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style={{ color: "#1e293b", fontWeight: "400" }}>${item.recruiterRate}</div>
                                                            <div className="text-muted" style={{ fontSize: "12px", color: "#64748b" }}>
                                                                <Moment format="MMM DD">{item.recruiterEffectiveDate}</Moment>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div style={{ color: "#1e293b", fontWeight: "400" }}>${item.agencyRate}</div>
                                                            <div className="text-muted" style={{ fontSize: "12px", color: "#64748b" }}>
                                                                <Moment format="MMM DD">{item.agencyEffectiveDate}</Moment>
                                                            </div>
                                                        </td>
                                                        <td style={{ fontSize: "14px", color: "#1e293b" }}>{item.notes || <span className="text-muted italic" style={{ color: "#64748b" }}>—</span>}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

export default AddEditRates;
